export enum UberPaymentEvent {
  START_CHECKOUT = "START_CHECKOUT",
  PAYMENT_SUCCESS = "PAYMENT_SUCCESS",
  PAYMENT_MODAL_OPENED = "PAYMENT_MODAL_OPENED",
  PAYMENT_MODAL_CLOSED = "PAYMENT_MODAL_CLOSED",
}

export interface StartPaymentRequest {
  type: UberPaymentEvent.START_CHECKOUT;
  payload: {
    quoteToken: string;
  };
}

export type PaymentEventResponse =
  | IPaymentEventResponse
  | IPaymentEventSuccessResponse;

export interface IPaymentEventResponse {
  type: UberPaymentEvent;
}

export interface IPaymentEventSuccessResponse {
  type: UberPaymentEvent.PAYMENT_SUCCESS;
  payload: {
    paymentSessionToken: string; // Payment session token
    quoteToken: string; // Quote CipherText value
  };
}
